import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import {
  Warning,
  Delete,
} from '@mui/icons-material';

const FileDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  file,
  isDeleting = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="error" />
        Delete D3 File
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete the file <strong>"{file?.file_name || file?.fileName}"</strong>?
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> This action will permanently delete the D3 file and its associated data. 
            This action cannot be undone.
          </Typography>
        </Alert>
        <Typography variant="body2" color="text.secondary">
          All processed chunks and vector embeddings associated with this D3 file will be permanently removed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} /> : <Delete />}
        >
          {isDeleting ? 'Deleting...' : 'Delete D3 File'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileDeleteDialog;
